export default function TextField({
  label,
  name,
  value,
  onChange,
}) {
  return (
    <div>
      <div className="text-sm font-medium text-gray-700 mb-1">{label}</div>
      <input
        type="text"
        className="w-full rounded-lg border border-gray-300 bg-gray-50 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-gray-900 text-sm mb-2"
        value={ value || ""}
        onChange={(e) => onChange(name, e.target.value)}
      />
    </div>
  );
}
